import { useEffect } from "react";
import { Block } from "../../components/Block/Block";
import { FlexWrapper } from "../../components/FlexWrapper/FlexWrapper";
import { Header } from "../../components/Header/Header";
import s from "./style.module.scss";
import { OnBoarding } from "../../components/OnBoarding/OnBoarding";

export const OnBoardingPage = () => {
  useEffect(() => {
    localStorage.setItem("hasCompletedOnboarding", "true");
  }, []);
  return (
    <FlexWrapper className={s.wrapper}>
      <Header title="FL.ru" onBoarding />
      <Block borderRadius="top" className={s.block} wihoutPadding>
        <OnBoarding />
      </Block>
    </FlexWrapper>
  );
};
